
import api from '../api';

/**
 * Fetch coupons for a user.
 *
 * @param {string} userId - The ID of the user.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails or required parameters are not provided.
 */
const getCoupons = async () => {

  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/user/getCoupons`;

  try {
    const response = await api.get(endpoint);

    return response.data;
  } catch (error) {
    console.error(`Error fetching coupons for user :`, error);
    throw error;
  }
}

export default getCoupons;
